import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import UserDataService from '../services/localStorageService';
import execute from '../hooks/execute';
import { protectedResources } from '../config/msalConfig';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
 
  const { instance } = useMsal();
  let account;

  if (instance) {
      account = instance.getActiveAccount();
      console.log(instance.getAllAccounts());
  }



  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
          if(userDetails.id === account.localAccountId){
            return;
          }
          //console.log('fetchUserDetails from UserContext', account.idTokenClaims.email);
          const response = await execute("GET", `${protectedResources.api.baseEndPoint}/customerUsers/currentUserData`);
          if (response && response.success && response.data.IsActive) {
              UserDataService.setUserData({...response.data,
                id: account.localAccountId});
              setUserDetails({...response.data,
                name: account.name,
                //email: account.idTokenClaims.email,
                id: account.localAccountId,
              });
          } else {
              // Display user-friendly error message using Ant Design Modal
              Modal.error({
                title: 'Authentication Error',
                icon: <ExclamationCircleOutlined />,
                content: response.message || 'You are not allowed to log in.',
                centered: true,
                maskClosable: false,
                okText: 'OK',
                onOk: () => {
                  UserDataService.clearUserData();
                  instance.logoutRedirect();
                }
              });
          }
      } catch (error) {
          console.error(`Error verifying user: ${account.localAccountId}`, error);

          // Check if this is a 404 error (user not found)
          if (error.response?.status === 404 || error.status === 404) {
            Modal.error({
              title: 'User Not Found',
              icon: <ExclamationCircleOutlined />,
              content: error.response.message || error.message || 'Your account was not found in this application. You may be trying to access the wrong application (customer app vs. admin console).',
              centered: true,
              maskClosable: false,
              okText: 'OK',
              onOk: () => {
                UserDataService.clearUserData();
                instance.logoutRedirect();
              }
            });
          } else {
            // Generic error for other cases
            Modal.error({
              title: 'Authentication Error',
              icon: <ExclamationCircleOutlined />,
              content: 'An error occurred while verifying your account. Please try again.',
              centered: true,
              maskClosable: false,
              okText: 'OK',
              onOk: () => {
                UserDataService.clearUserData();
                instance.logoutRedirect();
              }
            });
          }
      }
    };
      //console.log('setting userDetails from account');
      if(account && account.localAccountId){
        console.log("Active account found", account, instance);
        fetchUserDetails();
      }else{
        console.log("No active account found", account, instance);
      }

  },[account, instance, userDetails.id]);

  return (
    <UserContext.Provider value={{ userDetails }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
